const nl = {
  // Header / Navigation
  'nav.sports': 'Sportweddenschappen',
  'nav.live': 'Live Wedden',
  'nav.games': 'Spellen',
  'nav.promotions': 'Promoties',
  'nav.deposit': 'Storten',
  'nav.myBets': 'Mijn Weddenschappen',
  'nav.news': 'Nieuws',
  'nav.account': 'Account',
  'nav.login': 'Inloggen',
  'nav.register': 'Registreren',
  'nav.logout': 'Uitloggen',

  // Sidebar
  'sidebar.search': 'Team, Evenement of Competitie',
  'sidebar.quickAccess': 'Snelle Toegang',
  'sidebar.topEvents': 'Top Evenementen',
  'sidebar.topKombis': 'Top Combi\'s',
  'sidebar.todayMatches': 'Wedstrijden van Vandaag',
  'sidebar.germanFootball': 'Duits Voetbal',
  'sidebar.europeanFootball': 'Europees Voetbal',
  'sidebar.topCompetitions': 'Top Competities',
  'sidebar.topSports': 'Top Sporten',
  'sidebar.allSports': 'Alle Sporten',
  'sidebar.showAllCategories': 'Toon alle categorieën',
  'sidebar.hideCategories': 'Verberg categorieën',

  // Sports
  'sport.football': 'Voetbal',
  'sport.tennis': 'Tennis',
  'sport.basketball': 'Basketbal',
  'sport.iceHockey': 'IJshockey',
  'sport.handball': 'Handbal',
  'sport.baseball': 'Honkbal',
  'sport.americanFootball': 'American Football',
  'sport.boxing': 'Boksen',
  'sport.cricket': 'Cricket',
  'sport.darts': 'Darts',
  'sport.rugby': 'Rugby',
  'sport.tableTennis': 'Tafeltennis',
  'sport.beachVolleyball': 'Beachvolleybal',
  'sport.esports': 'E-Sports',

  // Market Types
  'market.tip': 'Resultaat',
  'market.tipRemainingTime': 'Resterende Tijd',
  'market.firstHalf': '1e Helft',
  'market.overUnder': 'Over/Under',
  'market.doubleChance': 'Dubbele Kans',
  'market.bothTeamsScore': 'Beide teams scoren',

  // Bet Outcomes
  'outcome.fhHomeWinRemainingTime': '1H Thuiswinst Rest.',
  'outcome.fhDrawRemainingTime': '1H Gelijkspel Rest.',
  'outcome.fhAwayWinRemainingTime': '1H Uitwinst Rest.',
  'outcome.fhNextGoalHome': '1H Volgend Doelpunt Thuis',
  'outcome.fhNextGoalAway': '1H Volgend Doelpunt Uit',
  'outcome.nextGoalHome': 'Volgend Doelpunt Thuis',
  'outcome.nextGoalAway': 'Volgend Doelpunt Uit',
  'market.nextGoal': 'Volgend Doelpunt',
  'outcome.home': 'Thuis',
  'outcome.away': 'Uit',
  'outcome.homeWin': 'Thuiswinst',
  'outcome.draw': 'Gelijkspel',
  'outcome.awayWin': 'Uitwinst',
  'outcome.over': 'Over',
  'outcome.under': 'Under',
  'outcome.yes': 'Ja',
  'outcome.no': 'Nee',
  'outcome.fhHomeWin': '1H Thuiswinst',
  'outcome.fhDraw': '1H Gelijkspel',
  'outcome.fhAwayWin': '1H Uitwinst',
  'outcome.fhOver': '1H Over',
  'outcome.fhUnder': '1H Under',
  'outcome.homeWinRemainingTime': 'Thuiswinst (Rest.)',
  'outcome.drawRemainingTime': 'Gelijk (Rest.)',
  'outcome.awayWinRemainingTime': 'Uitwinst (Rest.)',

  // Section Titles
  'section.nextGames': 'Volgende Wedstrijden',
  'section.topEvents': 'Top Evenementen',
  'section.lastMinute': 'Last Minute',
  'section.live': 'Live',
  'section.next6Hours': 'Komende 6 Uur',
  'section.topKombis': 'Top Combi\'s',
  'section.topKombisSubtitle': 'van andere klanten',
  'section.showAll': 'Toon alles',
  'section.createMkPlus': 'MK+ maken',
  'section.viewAll': 'Alles',

  // Betting Slip
  'slip.title': 'Wedstrookje',
  'slip.empty': 'Je wedstrookje is leeg.',
  'slip.emptyHint': 'Selecteer nu je weddenschappen.',
  'slip.single': 'Enkelvoudig',
  'slip.combi': 'Combi',
  'slip.system': 'Systeem',
  'slip.stake': 'Inzet',
  'slip.totalStake': 'Totale Inzet',
  'slip.setStake': 'Inzet bepalen',
  'slip.totalOdds': 'Totale Notering',
  'slip.potentialWin': 'Potentiële Winst',
  'slip.placeBet': 'Plaats Weddenschap',
  'slip.openBets': 'Open Weddenschappen',
  'slip.viewTicket': 'Bekijk Ticket',
  'slip.noOpenBets': 'Je hebt geen open weddenschappen.',
  'slip.combiBet': 'Combi Weddenschap',
  'slip.singleBet': 'Enkelvoudige Weddenschap',
  'slip.singleBets': 'Enkelvoudige Weddenschappen',
  'slip.potentialWinShort': 'Pot. Winst',
  'slip.maxWin': 'Max. Winst',
  'slip.requestCashout': 'Vraag Cashout aan',
  'slip.combinations': 'Combinaties (Lijnen)',
  'slip.cashoutValue': 'Cashout Waarde',
  'slip.confirmCashout': 'Bevestig Cashout',
  'slip.errorRequestingQuote': 'Fout bij aanvragen notering.',
  'slip.cashoutFailed': 'Cashout mislukt.',
  'slip.error.payoutLimitExceeded': 'Maximale uitbetalingslimiet overschreden. Verlaag je inzet.',
  'slip.errorPlacingBet': 'Fout bij plaatsen weddenschap.',
  'slip.placementScore': 'Plaatsing :',
  'slip.currentScore': 'Huidig :',
  'slip.placingBet': 'Ticket aanmaken...',
  'slip.placingWait': 'Even geduld a.u.b...',
  'slip.placingBtn': 'Plaatsen...',
  'slip.betSuccess': 'Ticket Goedgekeurd',
  'slip.betSuccessDesc': 'Je weddenschap is succesvol geplaatst!',
  'slip.hasLockedBets': 'Je wedstrookje bevat geblokkeerde/opgeschorte weddenschappen.',

  // Live
  'live.noEvents': 'Geen live evenementen voor',
  'live.games': 'Wedstrijden',
  'live.sortBy': 'Sorteer op :',
  'live.time': 'Tijd',
  'live.competition': 'Competitie',
  'live.halfTime': '1e Helft',
  'live.ht': 'RUST',
  'live.ft': 'EINDE',

  // Time
  'time.today': 'Vandaag',
  'time.tomorrow': 'Morgen',
  'time.minutes': 'Min',
  'time.hoursShort': 'Uur',

  // Top Kombis Card
  'kombis.betsPlaced': 'Weddenschappen geplaatst',
  'kombis.combi': 'Combi',
  'kombis.totalOdds': 'Totale Notering',
  'kombis.tip': 'Tip',

  // Account
  'account.myAccount': 'Mijn Account',
  'account.loginPrompt': 'Log in om je account te beheren.',
  'account.verification': 'Account Verificatie',
  'account.management': 'Accountbeheer & Limieten',
  'account.transactions': 'Transacties',
  'account.personalData': 'Persoonlijke Gegevens',
  'account.responsibleGaming': 'Verantwoord Spelen',
  'account.meineDaten': 'Mijn Gegevens',
  'account.kontoverifizierung': 'Account Verificatie',
  'account.kontoverwaltung': 'Beheer & Limieten',
  'account.transaktionsverlauf': 'Transactiegeschiedenis',
  'account.guthaben': 'Saldo',
  'account.auszahlung': 'Uitbetaling',
  'account.einstellungen': 'Instellingen',
  'account.neuigkeiten': 'Nieuws',
  'account.apps': 'Tipico Apps',
  'account.kontakt': 'Contact',
  'account.abmelden': 'Uitloggen & Deactiveren',
  'account.userTabs.personal': 'Gebruikersgegevens',
  'account.userTabs.contact': 'Contactgegevens',
  'account.userTabs.password': 'Wachtwoord Wijzigen',
  'account.fields.name': 'Voor- en Achternaam :',
  'account.fields.username': 'Gebruikersnaam :',
  'account.fields.birthname': 'Geboortenaam :',
  'account.fields.birthdate': 'Geboortedatum :',
  'account.fields.email': 'E-mail :',
  'account.fields.emailChange': 'E-mail Wijzigen',
  'account.fields.lugasId': 'Lugas Speler ID :',
  'account.underConstruction': 'Dit gedeelte is nog in aanbouw.',
  'account.supportPlaceholder': 'Beschrijf je verzoek zo nauwkeurig mogelijk...',
  'account.salutationMr': 'Dhr.',
  'account.loginBtn': 'Inloggen',
  'account.transactions.title': 'Transactiegeschiedenis',
  'account.transactions.type': 'Type',
  'account.transactions.amount': 'Bedrag',
  'account.transactions.status': 'Status',
  'account.transactions.date': 'Datum',
  'account.transactions.id': 'Referentie ID',
  'account.transactions.noTransactions': 'Geen transacties gevonden.',
  'account.transactions.deposit': 'Storting',
  'account.transactions.withdrawal': 'Uitbetaling',
  'account.transactions.status.completed': 'Succesvol',
  'account.transactions.status.pending': 'In behandeling',
  'account.transactions.status.failed': 'Mislukt',
  'account.transactions.filter.all': 'Alles',
  'account.transactions.filter.startDate': 'Van :',
  'account.transactions.filter.endDate': 'Tot :',
  'account.transactions.filter.reset': 'Reset',
  'account.balance.title': 'Saldo & Portemonnee',
  'account.balance.total': 'Totaal Saldo',
  'account.balance.available': 'Beschikbaar',
  'account.balance.locked': 'Vergrendeld',
  'account.balance.realCash': 'Echt Geld',
  'account.balance.bonusCash': 'Bonussaldo',
  'account.balance.premiumWallet': 'Premium Portemonnee',
  'account.balance.depositAction': 'Geld Storten',
  'account.balance.withdrawAction': 'Geld Opnemen',
  'account.balance.recentActivity': 'Recente Activiteit',
  'account.balance.viewAllTransactions': 'Bekijk alle transacties',
  'account.notifications.title': 'Nieuws & Meldingen',
  'account.notifications.empty': 'Geen meldingen beschikbaar.',
  'account.notifications.markAllRead': 'Markeer alles als gelezen',
  'account.notifications.markRead': 'Markeer als gelezen',
  'account.notifications.viewAll': 'Toon alles',
  'account.withdrawal.title': 'Uitbetaling Aanvragen',
  'account.withdrawal.selectMethod': 'Selecteer Methode :',
  'account.withdrawal.amount': 'Uitbetalingsbedrag',
  'account.withdrawal.enterAmount': 'Voer bedrag in',
  'account.withdrawal.availableToWithdraw': 'Beschikbaar saldo :',
  'account.withdrawal.submit': 'Vraag Uitbetaling Aan',
  'account.withdrawal.processingTime': 'Duur',
  'account.withdrawal.instant': 'Direct',
  'account.withdrawal.bankDays': '1-3 werkdagen',
  'account.withdrawal.successMessage': 'Je uitbetalingsverzoek is succesvol ingediend!',
  'account.withdrawal.successSub': 'Het bedrag wordt binnenkort op je gekozen betaalmethode bijgeschreven.',
  'account.withdrawal.refId': 'Referentie ID :',
  'account.withdrawal.error.insufficient': 'Onvoldoende saldo.',
  'account.withdrawal.error.minimum': 'Het minimum uitbetalingsbedrag is 10 €.',
  'account.withdrawal.backToWallet': 'Terug naar Saldo',

  // Login/Register
  'auth.loginTitle': 'Inloggen',
  'login.failed': 'Inloggen mislukt',
  'login.invalidCredentials': 'Ongeldige inloggegevens',
  'auth.registerTitle': 'Registreren',
  'auth.email': 'E-mail',
  'auth.username': 'Gebruikersnaam',
  'auth.password': 'Wachtwoord',
  'auth.confirmPassword': 'Wachtwoord Bevestigen',
  'auth.noAccount': 'Nog geen account?',
  'auth.hasAccount': 'Heb je al een account?',
  'auth.welcomeTitle': 'Duik in de wereld van sportweddenschappen!',
  'auth.bonusTitle': 'Verdubbel je eerste storting',
  'auth.bonusSubtitle': 'tot 100 €',
  'auth.registrationOnlyGermany': 'Registratie is alleen beschikbaar vanuit Duitsland.',

  // My Bets
  'bets.myBets': 'Mijn Weddenschappen',
  'bets.active': 'Actief',
  'bets.settled': 'Afgehandeld',
  'bets.won': 'Gewonnen',
  'bets.lost': 'Verloren',
  'bets.pending': 'In behandeling',

  // Misc
  'match.mainBets': 'Hoofdweddenschappen',
  'match.allBets': 'Alle Weddenschappen',
  'misc.noOdds': 'Geen noteringen',
  'misc.matches': 'Wedstrijden',
  'misc.matchKombi': 'MatchCombo+',
  'misc.outrights': 'Outrights',
  'misc.statistics': 'Statistieken',
  'misc.search': 'Zoeken',
  'misc.close': 'Sluiten',
  'misc.back': 'Terug',
  'misc.events': 'Evenementen',
  'misc.topCompetitions': 'Top Competities',
  'misc.noMatches': 'Geen wedstrijden gevonden.',
  'misc.loading': 'Laden…',
  'misc.confirmColon': 'Bevestig :',
  'misc.confirm': 'Bevestig',
  'misc.cancel': 'Annuleren',
  'misc.error': 'Fout.',
};

export default nl;
